import { Component, ElementRef, Input, ViewChild, OnInit, AfterViewInit, OnDestroy, TemplateRef, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sd-modal-control',
  templateUrl: './modal-control.component.html',
  styleUrls: ['../../assets/css/scrollbar.scss', './modal-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line: component-class-suffix
export class ModalControl implements OnInit, OnDestroy {
  static index = 0;
  @ViewChild('templateRef') templateRef: TemplateRef<any>;
  @Input() title: string;
  @Input() type: 'primary' | 'info' | 'success' | 'warning' | 'danger';
  @Input() width: 'lg' | 'md' | 'sm' | string;
  @Input() height = 'auto';
  @Input() view: 'dialog' | 'bottomSheet';
  @ViewChild('modal') modal: ElementRef;
  isOpened = false;
  alreadyOpened = false;
  isMobileOrTablet = false;
  private bottomSheetRef: MatBottomSheetRef<any>;
  private dialogRef: MatDialogRef<any>;
  private subcription = new Subscription();
  constructor(
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }
  ngOnInit(): void {
    this.type = this.type || 'primary';
    this.width = this.width || '80vw';
    if (!this.isMobileOrTablet) {
      switch (this.width) {
        case 'lg':
          this.width = '80vw';
          break;
        case 'md':
          this.width = '60vw';
          break;
        case 'sm':
          this.width = '40vw';
          break;
      }
    }
  }

  ngOnDestroy() {
    this.subcription?.unsubscribe();
  }

  open = (): void => {
    if (this.isOpened) {
      return;
    }
    this.alreadyOpened = true;
    this.isOpened = true;
    if ((!this.view && this.isMobileOrTablet) || this.view === 'bottomSheet') {
      this.bottomSheetRef = this.bottomSheet.open(this.templateRef);
      this.subcription.add(this.bottomSheetRef.afterDismissed().subscribe(() => {
        this.isOpened = false;
      }));
    } else {
      this.dialogRef = this.dialog.open(this.templateRef, {
        width: this.width
      });
      this.subcription.add(this.dialogRef.afterClosed().subscribe(() => {
        this.isOpened = false;
      }));
    }
  }

  close = (): void => {
    this.bottomSheetRef?.dismiss();
    this.dialogRef?.close();
  }
}
